import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

enum AutomationOrderItem {
  name = '1',
}

const nameConfig = {
  name: new Map([
    [Locale.ja, '名称'],
    [Locale.en, 'Name'],
  ]),
};

const toDisplay = enumToName(AutomationOrderItem, nameConfig);
const toDisplayWithPrefix = enumToName(AutomationOrderItem, nameConfig, { prefix: true });

export const automationOrderItem = {
  enum: AutomationOrderItem,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AutomationOrderItem };
